export default __webpack_public_path__ + "static/media/BazookaZombie.3a607e35.png";